import { useState } from 'react';
import { RewardsSystem } from '@/components/customer/RewardsSystem';
import { useLanguage } from '@/contexts/LanguageContext';

export function PointsPage() {
  const [isRewardsExpanded, setIsRewardsExpanded] = useState(true);
  const { t } = useLanguage();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight mb-2">{t('rewards.title')}</h1>
        <p className="text-muted-foreground">
          {t('rewards.description')}
        </p>
      </div>

      <RewardsSystem 
        isExpanded={isRewardsExpanded}
        onExpandChange={setIsRewardsExpanded}
      />
    </div>
  );
}